import { Vue } from "vue-class-component";
import { Project } from "./interfaces";

export const projects: Array<Project> = [
  {
    isPrior: false,
    category: ["web"],
    title: "PePlaace About",
    links: { link: "https://peplaace-about.netlify.app/" },
    tags: ["Web", "Vue", "Professional"],
    description: `Basic PePlaace about. Talks about the team, branding, projects e.t.c`,
  },
  {
    isPrior: false,
    category: ["web"],
    title: "PePlaace Authentication",
    links: { link: "https://auth-peplaace.netlify.app/" },
    tags: ["Web", "Vue", "Professional"],
    description: `Developed for PePlaace Rwanda, handles their authentication frontend activities.`,
  },
  {
    isPrior: false,
    category: ["web"],
    title: "(Former) Artistika",
    links: { link: "https://artistika.netlify.app/" },
    tags: ["Web", "Angular", "MongoDB", "Professional"],
    description:
      "Designed and developed a website concept for Artistika Studio. The website was to serve as local movie streaming platform.",
  },
  {
    isPrior: true,
    category: ["web"],
    title: "E4T",
    time: "2021 - Present",
    links: { link: "https://equity4talent.com/" },
    tags: [
      "Web",
      "NestJs",
      "NodeJs",
      "API",
      "AWS",
      "Vue",
      "UI/UX",
      "Marketplace",
      "Professional",
    ],
    image: "E4T.png",
    description:
      "Equity4Talent is a platform that helps founders match with entrepreneurial talents.<br /><br /> Focusing on product development, as a designger and a software developer | engineer, we managed to put on the market an interconnected system that has Talent, Founder, Admin, Authentication, and About platforms.",
  },
  {
    isPrior: true,
    category: ["mobile", "api"],
    title: "ElectroPessa",
    time: "2022 - Present",
    links: {},
    tags: [
      "Flutter",
      "Mobile",
      "NestJs",
      "NodeJs",
      "GraphQL",
      "UI/UX",
      "FinTech",
      "Professional",
    ],
    image: "ElectroChange.png",
    description:
      "An e-payment and money exchange platform to help clients & businesses make fast, easy, private, and secured transaction. <br /><br /> Focused on enhancing the idea and designing the concept. <br /><br /> Developed the GraphQL API with NestJs, and develop(ing) the two mobile apps (Business & Client) with Flutter.",
  },
  {
    isPrior: true,
    category: ["web"],
    title: "BlackHacks Studios",
    time: "2020 - 2021",
    links: { link: "https://blackhacks-studio.netlify.app/" },
    tags: ["Web", "Vue", "Professional"],
    image: "BlackHacks.png",
    description:
      "Designed and built our Studio's (about) website. Includes some parallax effects and fancying effects. <br /><br /> Unfortunately BlackHacks no-longer exists but the art and work of our hands still exists (Ex: MyKibo Africa).",
  },
  {
    isPrior: true,
    category: ["web"],
    title: "Costwise Store",
    time: "2021 - 2019",
    links: { link: "https://store.costwisecontractors.com" },
    tags: ["Web", "Vue", "NestJs", "Rest API", "Digital Ocean", "DevOps", "Professional"],
    image: "CocoStore.png",
    description:
      "Developed for CostwiseContractors Ltd as a store management web application. <br /><br /> Started with UI/UX as any of their projects, then developed a NestJs API, and later on developed the VueJs web app!",
  },
  {
    isPrior: true,
    category: ["web"],
    title: "Costwise Procurement",
    time: "2021 - 2019",
    links: { link: "https://procurement.costwisecontractors.com" },
    tags: ["Web", "Vue", "NestJs", "Rest API", "Digital Ocean", "DevOps", "Professional"],
    image: "CocoProcurement.png",
    description:
      "Developed for CostwiseContractors Ltd as a procurement management web application. <br /> ",
  },
  {
    isPrior: true,
    category: ["web"],
    title: "Costwise HR",
    time: "2021 - 2019",
    links: { link: "https://hr.costwisecontractors.com" },
    tags: ["Web", "Vue", "NestJs", "Rest API", "Digital Ocean", "DevOps", "Professional"],
    image: "CocoHR.png",
    description:
      "Developed for Costwise Contractors Ltd as an HR management web application.",
  },
  {
    isPrior: true,
    category: ["web"],
    title: "MyKibo",
    time: "2021 - 2021",
    links: { link: "https://mykibo.com/products/2107" },
    tags: ["Web", "Vue", "DevOps", "Frontent", "", "Professional"],
    image: "MyKibo.png",
    description:
      "Developed their marketplace as a frontend developer and their DevOps. <br /><br />Assisted in some Data migration from MySQL to PostgreSQL, and some backend dev with NodeJs (ES6).",
  },
  {
    isPrior: true,
    category: ["web"],
    title: "BigBox Overview (Concept)",
    time: "2019 - 2020",
    links: { link: "https://bigbox.netlify.app/" },
    tags: ["Web", "Vue", "Professional"],
    image: "BigBox.png",
    description: `Developed for PePlaace Rwanda, was a basic implementation of their e-commerce project called BigBox.`,
  },
  {
    isPrior: false,
    category: ["web"],
    title: "Medium Clone",
    time: "2019",
    links: { link: "https://nehemie-medium-clone.netlify.app/" },
    tags: ["Web", "React", "Exercise"],
  },
  {
    isPrior: false,
    category: ["web"],
    title: "Sinoterry",
    time: "2021",
    links: { link: "https://sinoterry.rw/" },
    tags: ["Web", "HTML", "CSS", "SCSS", "Tailwind CSS", "Professional"],
  },
  {
    isPrior: false,
    category: ["web"],
    title: "(Former)Recovery Rwanda",
    time: "2019",
    links: { link: "https://recoveryrwanda.netlify.app/" },
    tags: ["Web", "HTML", "CSS", "Professional"],
  },
  {
    isPrior: false,
    category: ["web"],
    title: "Contacts",
    time: "2019",
    links: { link: "https://nehemie-scrum-phonebook.netlify.app/" },
    tags: ["Web", "React", "Exercise"],
  },
  {
    isPrior: false,
    category: ["web"],
    time: "2018",
    title: "Televangelist",
    links: { link: "https://thetelevangelist.netlify.app/" },
    tags: ["Web", "Vue", "Professional"],
  },
];
